import { SHOW_SESSION_EXPIRED_MODAL, HIDE_SESSION_EXPIRED_MODAL } from './ActionSession';

const initialState = {
  showExpiredModal: false,
};

export function ReducerSession(state = initialState, action: any) {
  switch (action.type) {
    case SHOW_SESSION_EXPIRED_MODAL:
      return { ...state, showExpiredModal: true };
    case HIDE_SESSION_EXPIRED_MODAL:
      return { ...state, showExpiredModal: false };
    default:
      return state;
  }
}
